import { get } from '@/utils/vuex'

export default {
  getLoaderQueue: get("loaderQueue"),
  getDrawer: get("drawer"),
  getUser: get("user"), 
  getUserName: get("userName"), 
  getUserCountry: get("userCountry"),
  getLanguage: get("language"),
  getPageNotFoundDescription: get("pageNotFoundDescription"),
  getDocuments: get("documents"),
  getIsAuthenticated: get("isAuthenticated")
}
